<template>
  <div class="home-banner-container">
    <!-- 模糊背景层 -->
    <div 
      class="banner-bg" 
      :style="{ backgroundImage: `url(${activeBannerImage})` }"
    ></div>

    <!-- 轮播图主体 -->
    <div class="banner-content">
      <van-swipe 
        class="my-swipe" 
        :autoplay="3000" 
        indicator-color="white"
        @change="onChange"
      >
        <van-swipe-item v-for="(item, index) in banners" :key="index" @click="handleBannerClick(item)">
          <div class="banner-item-wrapper">
             <van-image :src="item.image" fit="cover" radius="12px" class="banner-img" />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { Swipe, SwipeItem, Image as VanImage } from 'vant';

export default {
  name: 'HomeBanner',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [VanImage.name]: VanImage,
  },
  setup() {
    const activeIndex = ref(0);
    
    const banners = [
      {
        image: 'https://img1.rrzuji.cn/uploads/images/26/01/03/594C025DC9921301.png',
        // image: require('@/assets/banner/banner1.png'),
        link: 'https://u.jd.com/JOODUEx',
        title: '年货节大促主会场'
      },
      {
        image: 'https://img1.rrzuji.cn/uploads/images/26/01/03/594C025DC9921301.png',
        // image: require('@/assets/banner/banner2.png'),
        link: 'https://u.jd.com/JOODUEx',
        title: '年货节大促主会场'
      }
    ];

    const activeBannerImage = computed(() => {
       if (banners.length > 0 && banners[activeIndex.value]) {
         return banners[activeIndex.value].image;
       }
       return '';
    });

    const onChange = (index) => {
      activeIndex.value = index;
    };

    const handleBannerClick = (item) => {
      if (item.link) {
        window.open(item.link, '_blank');
      }
    };

    return {
      banners,
      activeIndex,
      activeBannerImage,
      onChange,
      handleBannerClick
    };
  }
};
</script>

<style scoped>
.home-banner-container {
  position: relative;
  width: 100%;
  padding-top: 10px; /* 顶部留白 */
  padding-bottom: 10px;
  overflow: hidden;
  background: #f7f8fa;
}

/* 背景模糊层 */
.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%; /* 背景只占上半部分 */
  background-size: cover;
  background-position: center;
  filter: blur(20px); /* 高斯模糊 */
  opacity: 0.6; /* 透明度调整 */
  z-index: 0;
  transition: background-image 0.5s ease;
}

/* 渐变遮罩，让模糊背景底部自然过渡到白色 */
.banner-bg::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: linear-gradient(to bottom, rgba(247,248,250,0), #f7f8fa);
}

.banner-content {
  position: relative;
  z-index: 1;
  padding: 0 12px; /* 两侧间距 */
}

.my-swipe {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08); /* 阴影提升层次感 */
}

.banner-item-wrapper {
  width: 100%;
  height: 150px; /* 轮播图高度 */
  background: #fff;
}

.banner-img {
  width: 100%;
  height: 100%;
  display: block;
}

/* 自定义指示器样式优化（可选，Van UI默认其实也可以） */
:deep(.van-swipe__indicator) {
  width: 6px;
  height: 6px;
  opacity: 0.5;
  background-color: #fff;
}
:deep(.van-swipe__indicator--active) {
  opacity: 1;
  width: 12px;
  border-radius: 3px;
  background-color: #fff;
}
</style>
